// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"52":"73102a0b","453":"3359496c","995":"4868fe25"}[chunkId] + ".chunk.js");